"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.custom-branding.disabled': 'Custom branding feature is not available in your current plan.',
};
